import {Component, computed, inject, input, output, signal} from '@angular/core';
import {NgClass} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {TableModule} from 'primeng/table';
import {Button} from 'primeng/button';
import {InputText} from 'primeng/inputtext';
import {Tooltip} from 'primeng/tooltip';
import {TaTemplateSummary} from '../../../../api';
import {TemplateDatasource} from '../../../../datasources/template.datasource';
import {ScrollHeightDirective} from '../../../directives/scroll-height.directive';
import {LocationService} from '../../../../services/location.service';
import {fuzzyMatcher} from '../../../../util/search.utils';

/** The My TA Templates tab. */
@Component({
  selector: 'my-templates-list',
  imports: [
    NgClass,
    FormsModule,
    TableModule,
    Button,
    InputText,
    Tooltip,
    ScrollHeightDirective,
  ],
  templateUrl: './my-templates-list.html',
})
export class MyTemplatesList {
  templateDatasource = inject(TemplateDatasource);
  locationService = inject(LocationService);

  selectedId = input<string | undefined>();
  createDisabled = input<boolean>(false);
  createDisabledMessage = input<string>('');
  selected = output<TaTemplateSummary>();
  createTa = output<TaTemplateSummary>();
  editTemplate = output<TaTemplateSummary>();

  searchStr = signal<string>('');
  filteredTemplates = computed<TaTemplateSummary[]>(() => {
    const matches = fuzzyMatcher(this.searchStr());
    return this.templateDatasource.templates().filter(template => matches([], [template.name, template.purpose]));
  });
}
